import { render } from "./HomeV2SectionTwoCMS.vue?vue&type=template&id=6e4c6f5b"
import script from "../js/home-banner-slider.js?vue&type=script&lang=js"
export * from "../js/home-banner-slider.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__